// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3c1B9","calendarButtons":"ClockData_calendarButtons___A_Xn"};